import { defaultStore, stores } from '../translations'
import useServiceData from './useServiceData'
import { useEffect } from 'react'
import { image } from '../utils/data/baseUrl'
import { useModalsDataActions } from './useModalsDataActions'
import { useAppState } from '../redux/reducer/content'
import { august2026ChangesData } from '../constants/copyright'

export const useChangesAugust2026 = (modalServiceDataKey) => {
  const { get, save } = useServiceData()
  const { addModal } = useModalsDataActions()
  const state = useAppState()

  // Изменить дату начала на актуальную после тестирования
  const startDate = new Date('2026-09-02T00:00:00')
  const endDate = new Date('2026-09-13T23:59:59')
  const now = new Date()
  const isActive =
    now >= startDate && now <= endDate && ![stores.ru, stores.kz].includes(defaultStore)

  const setServiceData = () => {
    save(modalServiceDataKey, true)
  }

  useEffect(() => {
    if (!isActive) {
      return
    }

    const modalFromServiceData = get(modalServiceDataKey)

    if (!modalFromServiceData) {
      addModal({
        id: 'onboardingModal',
        type: 'onboardingModal',
        props: {
          image: image(august2026ChangesData[state].image),
          title: august2026ChangesData[state].title,
          description: august2026ChangesData[state].description,
          buttons: [
            {
              attr: {
                text: august2026ChangesData[state].button,
                disposable: true,
                modalData: { action: 'close', data: { type: 'current' } },
                customCallbacks: { setServiceData },
                callbackKey: ['setServiceData'],
              },
            },
          ],
        },
      })
    }
  }, [isActive])
}
